// extracted by mini-css-extract-plugin
module.exports = {"statusInner":"transactionStatus_statusInner__2EOv1","statusInnerDetail":"transactionStatus_statusInnerDetail__2LMHY"};